import { BaseComponent } from "../base/BaseComponent";
import { appDomain } from "../../domain/domain";
import { ICard } from "../../domain/cards/ICard";
import React from "react";
import { CardListItem } from "./CardListItem";
import { ButtonToolbar, Button } from "react-bootstrap";

interface CardListState {
    cards: ICard[];
}

export class CardList extends BaseComponent<{}, CardListState> {
    constructor(props: {}) {
        super(props);
        this.state = { cards: [] };
    }
    componentDidMount() {
        super.componentDidMount();
        this.loadData();
    }
    async loadData() {
        const cards = await appDomain.cardService.getAll();
        if (this.mounted) {
            this.setState({ cards });
        }
    }
    async addCard() {
        const card = {
            sideA: {
                title: "Side A"
            },
            sideB: {
                title: "Side B"
            }
        } as ICard;
        await appDomain.cardService.save(card);
        await this.loadData();
    }
    cardUpdated(card?: ICard, deleted?: boolean) {
        if (deleted)
            this.loadData();
    }
    render() {
        const cards = this.state.cards;
        const addCard = this.addCard.bind(this);
        const cardUpdated = this.cardUpdated.bind(this);
        return (<div>
            {cards.map(c => <CardListItem key={(c as any)._id} card={c} onUpdate={cardUpdated} />)}
            <ButtonToolbar>
                <Button variant="primary" onClick={addCard}>Add card</Button>
            </ButtonToolbar>
        </div>);
    }
}
